routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    // .state('home.productDetail', {
    //   url: "/categories",
    //   template: `<product-detail sh-ctrl="shCtrl"></product-detail>`
    // })
    .state('home.productDetailSlug', {
      url: "/product-detail-slug/{productSlug}",
      template: `<product-detail sh-ctrl="shCtrl"></product-detail>`
    })
    .state('home.productDetailId', {
      url: "/product-detail-id/{productId}",
      template: `<product-detail sh-ctrl="shCtrl"></product-detail>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/product-detail/product-detail.config.js
 **/